<template>
  <section class="hit-calculator-checkboxes-filters-settings settings">
    <header>
      <h1 class="page-header">Hit calculator checkboxes filters</h1>
    </header>
    <p v-if="userDefinedFilters.length === 0">No user defined filters.</p>
    <section v-else>
      <section
        v-for="(filter, index) in userDefinedFilters"
        v-bind:key="'filter-' + index"
        class="filter-container"
      >
        <p>
          Filter name: <input v-model="filter.name">
          <span v-on:click="removeFilter(index)" class="glyphicon glyphicon-remove"></span>
        </p>
        <five-card-hands-section
          v-bind:playerState="{
            fiveCardHands: filter.fiveCardHands,
            name: 'afterFlop',
            hasSimulationBeenRun: true,
            generalHands: {
              numberOfPossibleSpecificHands: 1326,
            },
          }"
          v-bind:hideHeader="true"
          v-bind:showPercentagesOrCombos="false"
          v-bind:hideRightContainer="true"
          v-on:setCheckedValueOfFiveCardHand="setCheckedValueOfFiveCardHand(filter.fiveCardHands, $event)"
          v-on:toggleCollapsedValueOfFiveCardHandParent="toggleCollapsedValueOfFiveCardHandParent($event)"
        ></five-card-hands-section>
      </section>
    </section>
    <hr>
    <section class="buttons">
      <button class="btn btn-default btn-lg" v-on:click="isHelpVisible = !isHelpVisible">
        <span v-if="!isHelpVisible">Show help <span class="caret-down"></span></span>
        <span v-if="isHelpVisible">Hide help <span class="caret-up"></span></span>
      </button>
      <button class="btn btn-default btn-lg" v-on:click="addFilter()">
        Add filter
      </button>
      <button class="btn btn-primary btn-lg" v-on:click="save()">
        Save
      </button>
    </section>
    <section v-if="isHelpVisible" class="well">
      <section class="embed-responsive embed-responsive-16by9">
        <iframe class="embed-responsive-item" width="560" height="315" src="https://www.youtube.com/embed/TVFelYdHtBw?rel=0&amp;showinfo=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
      </section>
    </section>
  </section>
</template>

<script>
import FiveCardHands from '@/services/five-card-hands/FiveCardHands';
import FiveCardHandsSection from '@/components/five-card-hands-section/five-card-hands-section';

export default {
  name: 'hit-calculator-checkboxes-filters-settings',
  components: {
    'five-card-hands-section': FiveCardHandsSection,
  },
  data: function () {
    let userDefinedFilters = [];

    this.$store.state.account.user.settings.hitCalculator.userDefinedFilters.forEach(function (userDefinedFilterFromSettings) {
      let userDefinedFilterToAdd = {
        name: userDefinedFilterFromSettings.name,
        fiveCardHands: new FiveCardHands(),
      };

      userDefinedFilterToAdd.fiveCardHands.madeHands.forEachLeaf(function (madeHandLeaf) {
        if (userDefinedFilterFromSettings.fiveCardHands.madeHands.includes(madeHandLeaf.id)) {
          madeHandLeaf.checked = true;
        }
      });
      userDefinedFilterToAdd.fiveCardHands.draws.forEachLeaf(function (drawLeaf) {
        if (userDefinedFilterFromSettings.fiveCardHands.draws.includes(drawLeaf.id)) {
          drawLeaf.checked = true;
        }
      });
      userDefinedFilterToAdd.fiveCardHands.combos.forEachLeaf(function (comboLeaf) {
        if (userDefinedFilterFromSettings.fiveCardHands.combos.includes(comboLeaf.id)) {
          comboLeaf.checked = true;
        }
      });
      userDefinedFilters.push(userDefinedFilterToAdd);
    });

    return {
      userDefinedFilters: userDefinedFilters,
      isHelpVisible: false,
    };
  },
  methods: {
    addFilter: function () {
      this.userDefinedFilters.push({
        name: '',
        fiveCardHands: new FiveCardHands(),
      });
    },
    removeFilter: function (index) {
      this.userDefinedFilters.splice(index, 1);
    },
    setCheckedValueOfFiveCardHand: function (fiveCardHands, payload) {
      fiveCardHands.find(payload.fiveCardHandId).checked = payload.newCheckedValue;
    },
    toggleCollapsedValueOfFiveCardHandParent: function (fiveCardHandParent) {
      fiveCardHandParent.collapsed = !fiveCardHandParent.collapsed;
    },
    areUserDefinedFiltersValid: function () {
      let userDefinedFilter;

      for (let i = 0; i < this.userDefinedFilters.length; i++) {
        userDefinedFilter = this.userDefinedFilters[i];

        if (userDefinedFilter.name.length === 0) {
          return false;
        }
      }

      return true;
    },
    save: function () {
      if (!this.areUserDefinedFiltersValid()) {
        alert('Make sure that all filters have a name.');
        return;
      }

      let self = this;
      let user = _.cloneDeep(this.$store.state.account.user);

      user.settings.hitCalculator.userDefinedFilters = this._getUserDefinedFiltersForServer();
      self.$http.put(`${process.env.BASE_API_URL}/user`, { user: user }).then(function (res) {
        self.$store.commit('account/setUser', res.data.user);
        alert('Saved!');
      }).catch(function () {
        alert('Unable to save settings.');
      });
    },
    _getUserDefinedFiltersForServer: function () {
      let userDefinedFilterForServer;
      let userDefinedFiltersForServer = [];

      this.userDefinedFilters.forEach(function (userDefinedFilter) {
        userDefinedFilterForServer = this.__getUserDefinedFilterForServer(userDefinedFilter);
        userDefinedFiltersForServer.push(userDefinedFilterForServer);
      }, this);

      return userDefinedFiltersForServer;
    },
    __getUserDefinedFilterForServer: function (userDefinedFilter) {
      let userDefinedFilterForServer = {
        name: userDefinedFilter.name,
        fiveCardHands: {
          madeHands: [],
          draws: [],
          combos: [],
        },
      };

      userDefinedFilter.fiveCardHands.madeHands.forEachCheckedLeaf(function (checkedMadeHandLeaf) {
        userDefinedFilterForServer.fiveCardHands.madeHands.push(checkedMadeHandLeaf.id);
      });
      userDefinedFilter.fiveCardHands.draws.forEachCheckedLeaf(function (checkedDrawLeaf) {
        userDefinedFilterForServer.fiveCardHands.draws.push(checkedDrawLeaf.id);
      });
      userDefinedFilter.fiveCardHands.combos.forEachCheckedLeaf(function (checkedComboLeaf) {
        userDefinedFilterForServer.fiveCardHands.combos.push(checkedComboLeaf.id);
      });

      return userDefinedFilterForServer;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import 'src/assets/settings';

  .five-card-hands-section {
    font-size: 12px;
  }

  .glyphicon-remove {
    color: grey;
    cursor: pointer;
  }

  .five-card-hands-section /deep/ .glyphicon-scale {
    display: none !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/settings/hit-calculator/checkboxes/filters.vue